import React from "react"

export const GatsbyCloudPricingIcon = ({
  height = 16,
  width = 16,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.66683 2.66669C2.31321 2.66669 1.97407 2.80716 1.72402 3.05721C1.47397 3.30726 1.3335 3.6464 1.3335 4.00002V6.66669C2.0735 6.66669 2.66683 7.26669 2.66683 8.00002C2.66683 8.35364 2.52635 8.69278 2.27631 8.94283C2.02626 9.19288 1.68712 9.33335 1.3335 9.33335V12C1.3335 12.3536 1.47397 12.6928 1.72402 12.9428C1.97407 13.1929 2.31321 13.3334 2.66683 13.3334H13.3335C13.6871 13.3334 14.0263 13.1929 14.2763 12.9428C14.5264 12.6928 14.6668 12.3536 14.6668 12V9.33335C14.3132 9.33335 13.9741 9.19288 13.724 8.94283C13.474 8.69278 13.3335 8.35364 13.3335 8.00002C13.3335 7.26002 13.9335 6.66669 14.6668 6.66669V4.00002C14.6668 3.26002 14.0668 2.66669 13.3335 2.66669H2.66683ZM10.3335 4.66669L11.3335 5.66669L5.66683 11.3334L4.66683 10.3334L10.3335 4.66669ZM5.8735 4.69335C6.52683 4.69335 7.0535 5.22002 7.0535 5.87335C7.0535 6.18631 6.92917 6.48645 6.70788 6.70774C6.48659 6.92903 6.18645 7.05335 5.8735 7.05335C5.22016 7.05335 4.6935 6.52669 4.6935 5.87335C4.6935 5.5604 4.81782 5.26026 5.03911 5.03897C5.2604 4.81767 5.56054 4.69335 5.8735 4.69335ZM10.1268 8.94669C10.7802 8.94669 11.3068 9.47335 11.3068 10.1267C11.3068 10.4396 11.1825 10.7398 10.9612 10.9611C10.7399 11.1824 10.4398 11.3067 10.1268 11.3067C9.4735 11.3067 8.94683 10.78 8.94683 10.1267C8.94683 9.81373 9.07115 9.51359 9.29244 9.2923C9.51374 9.07101 9.81387 8.94669 10.1268 8.94669Z"
        fill="currentColor"
      />
    </svg>
  )
}
